<template>
  <div class="SingleUploadButtons">
    <div ref="AttachToolBar">
      <div v-if="srcUrl" class="imagePreDiv" :style="{height: _height + 'px', width: _width + 'px', paddingRight: 12 + 'px' }">
        <el-image v-if="efileIsImage" :style="{height: _height + 'px', width: _width + 'px', paddingRight: 20 + 'px' }" :src="srcUrl" :fit="_fit" :preview-src-list="preSrcList"></el-image>
        <div v-else>
          <div>
            <div v-if="upDownloadStyle==='down'" class="pardiv" :style="{height: _height + 'px', width: _width + 'px' }">
              <i class="el-icon-bottom downicon" :style="{height: _height_up + 'px', width: _width + 'px', lineHeight: _height + 'px'}"></i>
            </div>
            <icon v-else-if="upDownloadStyle===''" :name="efileIcon" :scale="_scale" v-show="achViewState" class="efileIconDiv" @click="preEfile" ></icon>
          </div>
          <div>
            <mh-pdf-viewer ref="mpvBtn" displayBtn="none" :showBtn = "achViewState" vType="view" :vText="$t('common.preview')"
                           :rootDirCode = "rootDirCode" :rootDirField = "rootDirField"  :filePath="viewFilePath"
                           :fileName = "viewFileName" :fileDisplayName="viewDisplayFileName" @updateUpDown="updateUpDownStyle"></mh-pdf-viewer>
            <mh-pdf-viewer ref="mpdBtn" displayBtn="none" :showBtn = "achDownloadState" vType="download" :vText="$t('common.download')"
                           :rootDirCode = "rootDirCode" :rootDirField = "rootDirField"  :filePath="viewFilePath"
                           :fileName = "viewFileName" :fileDisplayName="viewDisplayFileName" @updateUpDown="updateUpDownStyle"></mh-pdf-viewer>
          </div>
        </div>
        <i class="el-icon-close delete_right" v-show="position==='form' && achDeleteState" @click="deleteAttachData"></i>
        <i class="el-icon-paperclip down_bottom" v-show="achDownloadState" @click="downEfile"></i>
      </div>
      <div class="uploadPreDiv" v-else>
        <el-button-group v-if="position==='form'">
          <el-upload class="uploadImageClass"
                     ref="upload"
                     action
                     :accept="acceptType"
                     :show-file-list="false"
                     :before-upload="beforeUpload"
                     :on-success="successUpload"
                     :on-error="errorUpload"
                     :http-request="handleUploadForm"
                     :data="uploadParaData"
                     :auto-upload="true"
                     :disabled="disabled">
            <div :class="{'upload-item-disabled':disabled, 'upload-form-disabled':formDisabled}">
              <div v-if="upDownloadStyle==='up'" class="pardiv" :style="{height: _height + 'px', width: _width + 'px'}">
                <i class="el-icon-top upicon" :style="{height: _height_up + 'px', width: _width + 'px', lineHeight: _height + 'px'}"></i>
              </div>
              <i v-else-if="upDownloadStyle===''" class="el-icon-plus avatarUploadIcon" :style="{height: _height + 'px', width: _width + 'px', lineHeight: _height + 'px'}"></i>
            </div>
          </el-upload>
        </el-button-group>
        <i class="el-icon-setting config_right" v-show="position==='form' && _canCfgPara" @click="showCfgPara"></i>
      </div>
    </div>
    <el-dialog :title="cfgTitle" :visible.sync="showCfgDlg" :close-on-click-modal="false" :show-close="false"
               :modal-append-to-body="false" width="50%" class="apprDlgClass" center>
      <div>
        <el-form :model="cfgPara" ref="cfgParaRef"
                 label-width="80px" label-position="right"
                 size="mini" >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('base.SingleUploadButtons.pictureWidth')" prop="width">
                <el-input v-model.number="cfgPara.aftWidth" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('base.SingleUploadButtons.pictureHeight')" prop="height">
                <el-input v-model.number="cfgPara.aftHeight" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('base.SingleUploadButtons.tolerance')" prop="diff">
                <el-input v-model.number="cfgPara.diff" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button size="mini" @click="cfgCancel" icon="el-icon-close">{{$t('common.cancel')}}</el-button>
          <el-button type="primary" size="mini" @click="cfgConfirm" icon="el-icon-check">{{$t('common.confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MhPdfViewer from '@/components/base/MhPdfViewer.vue'
export default {
  name: 'SingleUploadButtons',
  props: ['formDisabled', 'mObj', 'fileProps', 'position', 'disabled'],
  data () {
    return {
      showCfgDlg: false,
      cfgTitle: this.$t('base.SingleUploadButtons.pictureParameter'),
      cfgPara: {
        aftWidth: 250,
        aftHeight: 120,
        diff: 26
      },
      formMaxSize: 500,
      srcUrl: '',
      flag: false,
      upDownloadStyle: '',
      upDownloadPer: 0,
      uploadParaData: {},
      attachObj: {}
    }
  },
  computed: {
    achInsertState () {
      return !this.formDisabled && !this.fileReadOnly
    },
    achViewState () {
      return (this.viewFilePath !== '')
    },
    achDownloadState () {
      return (this.viewFilePath !== '') && (!this.fileViewOnly)
    },
    achDeleteState () {
      return (!this.formEdit && (this.viewFilePath !== '')) && !this.fileReadOnly && !this.formDisabled
    },
    fileViewOnly () {
      if (this.filePropsObj.viewOnly) {
        return true
      } else {
        return false
      }
    },
    fileReadOnly () {
      if (this.filePropsObj.readOnly) {
        return true
      } else {
        return false
      }
    },
    filePropsObj () {
      return JSON.parse(this.fileProps)
    },
    rootDirCode () {
      if (!this.filePropsObj.rootDirCode) {
        return 'SYSCFG_EDOC'
      } else {
        if (this.filePropsObj.rootDirCode.indexOf('$') === 0) {
          return this.mObj[this.filePropsObj.rootDirCode.replaceAll('$', '')]
        } else {
          return this.filePropsObj.rootDirCode
        }
      }
    },
    rootDirField () {
      if (!this.filePropsObj.rootDirField) {
        return 'sys_char1'
      } else {
        if (this.filePropsObj.rootDirField.indexOf('$') === 0) {
          return this.mObj[this.filePropsObj.rootDirField.replaceAll('$', '')]
        } else {
          return this.filePropsObj.rootDirField
        }
      }
    },
    _canCfgPara () {
      if (!this.filePropsObj._canCfgPara) {
        return false
      } else {
        return true
      }
    },
    _onlyDownLoad () {
      if (!this.filePropsObj._onlyDownLoad) {
        return false
      } else {
        return this.filePropsObj._onlyDownLoad
      }
    },
    _url () {
      if (!this.filePropsObj._url) {
        return '/edoc/uploadEdocFile'
      } else {
        return this.filePropsObj._url
      }
    },
    _scale () {
      if (this.position === 'form') {
        if (!this.filePropsObj._scale) {
          return 3.5
        } else {
          return this.filePropsObj._scale
        }
      } else {
        if (!this.filePropsObj._scale_table) {
          return 3
        } else {
          return this.filePropsObj._scale_table
        }
      }
    },
    _height () {
      if (this.position === 'form') {
        if (!this.filePropsObj._height) {
          return 50
        } else {
          return this.filePropsObj._height
        }
      } else {
        if (!this.filePropsObj._height_table) {
          return 50
        } else {
          return this.filePropsObj._height_table
        }
      }
    },
    _height_up () {
      if (this.position === 'form') {
        if (!this.filePropsObj._height) {
          return 80 * this.upDownloadPer
        } else {
          return this.filePropsObj._height * this.upDownloadPer
        }
      } else {
        if (!this.filePropsObj._height_table) {
          return 50 * this.upDownloadPer
        } else {
          return this.filePropsObj._height_table * this.upDownloadPer
        }
      }
    },
    _width () {
      if (this.position === 'form') {
        if (!this.filePropsObj._width) {
          return 50
        } else {
          return this.filePropsObj._width
        }
      } else {
        if (!this.filePropsObj._width_table) {
          return 50
        } else {
          return this.filePropsObj._width_table
        }
      }
    },
    _fit () {
      if (this.position === 'form') {
        if (!this.filePropsObj._fit) {
          return 'fill'
        } else {
          return this.filePropsObj._fit
        }
      } else {
        if (!this.filePropsObj._fit_table) {
          return 'fill'
        } else {
          return this.filePropsObj._fit_table
        }
      }
    },
    viewFileName () {
      if (!this.mObj) {
        return ''
      } else {
        return this.mObj[this.filePropsObj.efileNameProp]
      }
    },
    viewDisplayFileName () {
      if (!this.mObj) {
        return ''
      } else {
        return this.mObj[this.filePropsObj.efileDisplayProp]
      }
    },
    acceptType () {
      const that = this
      if (!that.filePropsObj.efileSuffix) {
        return ''
      } else {
        return that.filePropsObj.efileSuffix
      }
    },
    viewFilePath () {
      if (!this.mObj) {
        return ''
      } else {
        return this.mObj[this.filePropsObj.efilePathProp]
      }
    },
    preSrcList () {
      if (this.srcUrl === '') {
        return []
      } else {
        return [this.srcUrl]
      }
    },
    efileIsImage () {
      if (!this.mObj) {
        return false
      } else {
        const newName = this.mObj[this.filePropsObj.efileNameProp]
        const suffix = newName.substring(newName.lastIndexOf('.') + 1).toUpperCase()
        if ((suffix.toUpperCase() === 'JPG') || (suffix.toUpperCase() === 'BMP') || (suffix.toUpperCase() === 'PNG') || (suffix.toUpperCase() === 'JPEG')) {
          return true
        } else {
          return false
        }
      }
    },
    efileIcon () {
      if (!this.mObj) {
        return 'file'
      } else {
        const newName = this.mObj[this.filePropsObj.efileNameProp]
        const suffix = newName.substring(newName.lastIndexOf('.') + 1)
        if (suffix.toUpperCase() === 'PDF') {
          return 'file-pdf'
        } else if ((suffix.toUpperCase() === 'XLS') || (suffix.toUpperCase() === 'XLSX')) {
          return 'file-excel'
        } else if ((suffix.toUpperCase() === 'DOC') || (suffix.toUpperCase() === 'DOCX')) {
          return 'file-excel'
        } else if ((suffix.toUpperCase() === 'PPT') || (suffix.toUpperCase() === 'PPTX')) {
          return 'file-powerpoint'
        } else if ((suffix.toUpperCase() === 'JPG') || (suffix.toUpperCase() === 'BMP') || (suffix.toUpperCase() === 'PNG') || (suffix.toUpperCase() === 'JPEG')) {
          return 'file-image'
        } else {
          return 'file'
        }
      }
    },
    viewImageType () {
      const that = this
      if (!that.mObj) {
        return 'data:image/png;base64,'
      }
      const suffix = that.mObj[that.filePropsObj.efileNameProp].toUpperCase()
      if ((!suffix) || (suffix === '')) {
        return 'data:image/png;base64,'
      } else {
        if ((suffix.indexOf('JPG') > 0) || (suffix.indexOf('JPEG') > 0)) {
          return 'data:image/jpeg;base64,'
        } else if (suffix.indexOf('BMP') > 0) {
          return 'data:image/bmp;base64,'
        } else {
          return 'data:image/png;base64,'
        }
      }
    }
  },
  created () {
  },
  components: {
    MhPdfViewer
  },
  methods: {
    successUpload: function (response, file, fileList) {
      this.upDownloadStyle = ''
      this.upDownloadPer = 0
      this.$refs.upload.clearFiles()
    },
    errorUpload: function (err, file, fileList) {
      console.log(err)
      this.upDownloadStyle = ''
      this.upDownloadPer = 0
      this.$refs.upload.clearFiles()
    },
    beforeUpload: function (file) {
      const that = this
      if (that.fileReadOnly) {
        return false
      }
      if (file.size / 1024 / 1024 > that.formMaxSize) {
        that.$alert(this.$t('base.AttachDetGrid.sizeOfTheUpload') + `${that.formMaxSize}M!`, this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm')
        })
        return false
      }
      const efileSuffix = that.filePropsObj.efileSuffix.toUpperCase()
      if ((efileSuffix !== '') && (efileSuffix !== '*')) {
        var fileSuffix = file.name.substring(file.name.lastIndexOf('.')).toUpperCase()
        // const extension = fileSuffix === efileSuffix
        if (efileSuffix.indexOf(fileSuffix) === -1) {
          that.$alert(this.$t('base.AttachDetGrid.typeOfTheUpload') + `${efileSuffix}` + this.$t('base.AttachDetGrid.type'), this.$t('common.tips'), {
            confirmButtonText: this.$t('common.confirm')
          })
          return false
        } else {
          return true
        }
      }
    },
    handleUploadForm: async function (param) {
      const that = this
      const efType = that.mObj[that.filePropsObj.efileType] || that.filePropsObj.efileType
      const app = ''
      const nbr = that.mObj[that.filePropsObj.efileNbr]
      let lot = ''
      if (that.filePropsObj.efileLot !== '') {
        lot = that.mObj[that.filePropsObj.efileLot]
      }
      let line = 0
      if (that.filePropsObj.efileLine !== '') {
        line = that.mObj[that.filePropsObj.efileLine]
      }
      let code = ''
      if (that.filePropsObj.efileCode !== '') {
        code = that.mObj[that.filePropsObj.efileCode]
      }

      const formData = new FormData()
      formData.append('efType', efType)
      formData.append('app', app)
      formData.append('nbr', nbr)
      formData.append('lot', lot)
      formData.append('line', line)
      formData.append('code', code)
      formData.append('rootDirCode', that.rootDirCode)
      formData.append('rootDirField', that.rootDirField)
      formData.append('rootDirField', that.rootDirField)
      formData.append('width', that.cfgPara.aftWidth)
      formData.append('height', that.cfgPara.aftHeight)
      formData.append('diff', that.cfgPara.diff)
      formData.append('file', param.file)
      that.upDownloadPer = 0
      const { data: res } = await that.$http.post(that._url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress (progressEvent) {
          if (progressEvent.lengthComputable) {
            const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0)
            that.upDownloadStyle = 'up'
            that.upDownloadPer = val / 100
          }
        }
      })
      const flag = res.data.flag
      const msg = res.data.msg
      if (flag !== -1) {
        that.$alert(msg, this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm')
        })
      } else {
        const filePath = res.data.filePath
        const fileOldName = res.data.fileOldName
        const fileNewName = res.data.fileNewName
        that.mObj[that.filePropsObj.efilePathProp] = filePath
        that.mObj[that.filePropsObj.efileDisplayProp] = fileOldName
        // that.$set(that.mObj, that.filePropsObj.efileNameProp, fileNewName)
        that.mObj[that.filePropsObj.efileNameProp] = fileNewName
        that.flag = !that.flag
      }
    },
    deleteAttachData: function () {
      const that = this
      that.$confirm(this.$t('base.AttachDetGrid.confirmDeleteFile'), this.$t('base.AttachDetGrid.pleaseConfirm'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        that.mObj[that.filePropsObj.efilePathProp] = ''
        that.mObj[that.filePropsObj.efileDisplayProp] = ''
        // that.$set(that.mObj, that.filePropsObj.efileNameProp, '')
        that.mObj[that.filePropsObj.efileNameProp] = ''
        that.flag = !that.flag
      }).catch(() => {

      })
    },
    cfgCancel: function () {
      this.showCfgDlg = false
    },
    cfgConfirm: function () {
      this.showCfgDlg = false
    },
    showCfgPara: function () {
      this.showCfgDlg = true
    },
    preEfile: function () {
      if (this._onlyDownLoad) {
        this.$refs.mpdBtn.viewPdf()
      } else {
        this.$refs.mpvBtn.viewPdf()
      }
    },
    downEfile: function () {
      if (this.achDownloadState) {
        this.$refs.mpdBtn.viewPdf()
      }
    },
    updateUpDownStyle: function (upDownStyle, upDownPer) {
      this.upDownloadStyle = upDownStyle
      this.upDownloadPer = upDownPer
    }
  },
  beforeMount () {
  },
  mounted () {
    if (this.filePropsObj._aftWidth) {
      this.cfgPara.aftWidth = this.filePropsObj._aftWidth
    }
    if (this.filePropsObj._aftHeight) {
      this.cfgPara.aftHeight = this.filePropsObj._aftHeight
    }
    if (this.filePropsObj._diff) {
      this.cfgPara.diff = this.filePropsObj._diff
    }
  },
  watch: {
    viewFilePath: {
      async handler (newValue, oldValue) {
        const that = this
        const p = {
          rootDirCode: that.rootDirCode,
          rootDirField: that.rootDirField,
          filePath: newValue,
          fileName: '',
          reConvert: false
        }
        const url = '/edoc/downloadEdocFile'
        const { data: res } = await this.$http.post(url, p)
        const flag = res.data.flag
        if (flag !== -1) {
          if (this.viewFilePath === newValue) {
            that.srcUrl = ''
          }
        } else {
          if (this.viewFilePath === newValue) {
            const base64Str = res.data.base64Str
            that.srcUrl = that.viewImageType + base64Str
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" >
  .uploadImageClass {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .noimg {
    border: #7c869a 1px solid;
    height: 100px;
    width: 100px;
    cursor: pointer;
  }
  .uploadImageClass:hover {
    border-color: #409EFF;
  }
  .avatarUploadIcon {
    font-size: 18px;
    color: #8c939d;
    /*width: 78px;*/
    /*height: 78px;*/
    /*line-height: 78px;*/
    text-align: center;
  }
  .pardiv {
    position: relative;
  }
  .upload-item-disabled {
    background-color: #F5F7FA;
  }
  .upload-form-disabled {
    background-color: #F5F7FA;
  }
  .upicon {
    display: none;
    cursor: pointer;
    background-color: green;
    color: antiquewhite;
    font-size: 24px;
    opacity: 0.7;
    position: absolute;
    bottom: 1px;
    left: 1px;
    text-align: center;
  }
  .downicon {
    display: none;
    cursor: pointer;
    background-color: blue;
    color: antiquewhite;
    font-size: 24px;
    opacity: 0.7;
    position: absolute;
    top: 1px;
    text-align: center;
  }
  /*.avatarUpload {*/
  /*  width: 78px;*/
  /*  height: 78px;*/
  /*  display: block;*/
  /*}*/
  .imagePreDiv {
    border: #0a84ff 0px dotted;
    position: relative;
  }
  .imagePreDiv:hover i{
    display: block;
  }
  .uploadPreDiv {
    position: relative;
  }
  .uploadPreDiv:hover i {
    display: block;
  }
  .delete_right {
    display: none;
    cursor: pointer;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 5px;
    right: 1px;
  }
  .config_right {
    display: none;
    cursor: pointer;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .down_bottom {
    display: none;
    cursor: pointer;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 40px;
    right: 1px;
  }
  .efileIconDiv {
    cursor: pointer;
    padding-left: 9px;
    padding-top: 9px;
  }
</style>
